export const teamdata = [
    {
        id: 1,
        name: 'Ram Janam Singh',
        title: 'Faculty Co-ordinator',
        IGid: "https://www.instagram.com/ramjanmsingh/",
        linkedinid: "https://www.linkedin.com/company/ecell-medi-caps/",
        profile: require('../assets/images/team/ram.jpeg')
    },
    {
        id: 2,
        name: 'Arnav Mishra',
        title: 'Mentor',
        IGid: "https://www.instagram.com/arnavmishra.in/",
        linkedinid: "https://www.linkedin.com/company/ecell-medi-caps/",
        profile: require('../assets/images/team/arnav.png')
    },
    {
        id: 3,
        name: 'Ravindra Pathak',
        title: 'Faculty Co-ordinator',
        IGid: "https://www.instagram.com/ecell.medicaps/",
        linkedinid: "https://www.linkedin.com/company/ecell-medi-caps/",
        profile:require('../assets/images/team/Ravindra.jfif')
    },
    {
        id: 4,
        name: 'Sarita Kansal',
        title: 'Faculty Co-ordinator',
        IGid: "https://www.instagram.com/ecell.medicaps/",
        linkedinid: "https://www.linkedin.com/company/ecell-medi-caps/",
        profile: require('../assets/images/team/Sarita.jfif')
    },
    {
        id: 5,
        name: 'Ansh Sharma',
        title: 'President',
        IGid: "https://www.instagram.com/_ansh17__/",
        linkedinid: "https://www.linkedin.com/in/ansh-sharma-0a259b251",
        profile: require('../assets/images/team/Ansh.png')
    },
    {
        id: 6,
        name: 'Hitesh Uspariya',
        title: 'Vice President',
        IGid: "https://www.instagram.com/hitesh.us/",
        linkedinid: "https://www.linkedin.com/in/hitesh-uspariya-bb099120b/",
        profile: require('../assets/images/team/Hitesh.jfif')
    },
    {
        id: 7,
        name: 'Varun Menghani',
        title: 'Marketing Lead',
        IGid: "https://www.instagram.com/menghanivarun/",
        linkedinid: "https://www.linkedin.com/company/ecell-medi-caps/",
        profile: require('../assets/images/team/Varun.jfif')
    },
    {
        id: 8,
        name: 'Anmol Verma',
        title: 'Sponsorship Lead',
        IGid: "https://www.instagram.com/anmol____verma/",
        linkedinid: "https://www.linkedin.com/company/ecell-medi-caps/",
        profile: require('../assets/images/team/Anmol.jfif')
    },
    {
        id: 9,
        name: 'Shivani Shekhawat',
        title: 'Sales Lead',
        IGid: "https://www.instagram.com/_shivani__shekhawat_/",
        linkedinid: "https://www.linkedin.com/company/ecell-medi-caps/",
        profile: require('../assets/images/team/Shivani.jfif')
    },

    {
        id: 10,
        name: 'Aditi Mandlik',
        title: 'Content Lead',
        IGid: "https://www.instagram.com/aditimandlik/",
        linkedinid: "https://www.linkedin.com/in/aditi-mandlik-b95386209/",
        profile: require('../assets/images/team/Aditi.jfif')
    },
    {
        id: 11,
        name: 'Sakshi Mate',
        title: 'Content Lead',
        IGid: "https://www.instagram.com/sakshii_mate/",
        linkedinid: "https://www.linkedin.com/in/sakshi14mate/",
        profile: require('../assets/images/team/Sakshi.jfif')
    },
    {
        id: 12,
        name: 'Arin Bagul',
        title: 'Graphics Lead',
        IGid: "https://www.instagram.com/arinbagul/",
        linkedinid: "https://www.linkedin.com/in/arin-bagul/",
        profile: require('../assets/images/team/Arin.png')
    },
    {
        id: 13,
        name: 'Gazal Bandil',
        title: 'Graphics Lead',
        IGid: "https://www.instagram.com/ssgazalbandil/",
        linkedinid: "https://www.linkedin.com/in/gazal-bandil-7b6a11222/",
        profile: require('../assets/images/team/Gazal.jfif')
    },
    {
        id: 14,
        name: 'Ashwini Sahu',
        title: 'PR Lead',
        IGid: "https://www.instagram.com/aishwyny/",
        linkedinid: "https://www.linkedin.com/in/ashwini-sahu-3238611a9/",
        profile: require('../assets/images/team/Ashwini.jfif')
    },
    {
        id: 15,
        name: 'Ish Pandey',
        title: 'Management Lead',
        IGid: "https://www.instagram.com/ishpandey_/",
        linkedinid: "https://www.linkedin.com/in/ish-pandey-76a7791ab/",
        profile: require('../assets/images/team/Ish.jfif')
    },
    {
        id: 16,
        name: 'Moiz Chauhan',
        title: 'Technical Head',
        IGid: "https://www.instagram.com/moiz_chauhan_/",
        linkedinid: "https://www.linkedin.com/in/moiz-chauhan/",
        profile: require('../assets/images/team/Moiz.jfif')
    },
    {
        id: 17,
        name: 'Himadri Pathak',
        title: 'Technical Head',
        IGid: "https://www.instagram.com/pathak.himadri/",
        linkedinid: "https://www.linkedin.com/in/himadri-pathak-178234172/",
        profile: require('../assets/images/team/Himadri.jpg')
    },
]